import { createAction } from '@reduxjs/toolkit';

export const SET_CALL_FROM_ACTION_TYPE = 'saga/setCallFrom';
export const setCallFromAction = createAction(SET_CALL_FROM_ACTION_TYPE);
